module.exports = __webpack_public_path__ + "97534dd409492b05b11ab96b3dd4a557.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/LightItalic/OpenSans-LightItalic.woff?v=1.1.0
// module id = 979
// module chunks = 0